import { render, staticRenderFns } from "./changeLocale.vue?vue&type=template&id=99e8eb72&scoped=true&"
import script from "./changeLocale.vue?vue&type=script&lang=js&"
export * from "./changeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e8eb72",
  null
  
)

export default component.exports